<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/project">投资项目</router-link>
      <!-- <span>></span>
      <span>{{info.projectName}}</span> -->
    </div>
    <!-- <div class="title">
      <p><strong>{{info.projectName}}</strong></p>
    </div> -->
    <!-- <div class="banner">
      <img :src="info.projectHomePageUrl" alt="">
    </div> -->
    <div class="content-h" v-html="info.projectParticulars"></div>
  </div>
</template>

<script>
import { projectInfo } from '@/api/api'
export default {
  data() {
    return {
      info: {}
    }
  },
  created() {
    projectInfo({
      id: this.$route.query.id
    }).then(res => {
      this.info = res
      console.log(res)
    })
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  .breadcrumb {
    margin: 50px auto 50px;
  }
  .title {
    color: #1c3c8a;
    font-size: 30px;
    text-align: center;
    margin-bottom: 40px;
  }
}
</style>
